export default __webpack_public_path__ + "static/media/installation-video-ios-DA.51c08d46.mp4";